import React from 'react';
import { Popover } from '@mui/material';
import EmojiPicker from 'emoji-picker-react';

const EmojiPickerPopover = ({ anchorEl, open, onClose, onEmojiClick }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <EmojiPicker
        onEmojiClick={onEmojiClick}
        width={350}
        height={400}
        previewConfig={{ showPreview: false }}
        skinTonesDisabled
        searchDisabled={false}
      />
    </Popover>
  );
};

export default EmojiPickerPopover;
